import { mapEventPreviewFields } from '@/adapters/events'
import { directusClient, imageFields, readItems } from '@/shared/utils/directus'

export interface GetEventsParams {
  locale?: string
  categoryId?: number | string
  page?: number
  limit?: number
  sort?: string[]
  isPinned?: boolean
}

export default async function getEvents({
  locale = 'ru-RU',
  categoryId,
  page = 1,
  limit = 12,
  sort = ['-date_start'],
  isPinned = false,
}: GetEventsParams = {}) {
  const collectionName = 'events'

  const filter = {
    translations: { languages_code: { _eq: locale } },
    category: categoryId,
    is_pinned: isPinned,
  }

  try {
    const itemsRaw = await directusClient.request<Directus.EventPreview[]>(
      readItems(collectionName, {
        sort,
        page,
        limit,
        filter,
        deep: {
          translations: { _filter: { languages_code: { _eq: locale } } },
          category: {
            translations: { _filter: { languages_code: { _eq: locale } } },
          },
        },
        fields: [
          'id',
          'slug',
          'date_start',
          'date_end',
          'is_pinned',
          'age_restriction',
          {
            translations: ['title', 'location'],
            category: ['id', 'slug', 'color', { translations: ['name', 'name_plural'] }],
            image_preview: imageFields,
          },
        ],
      })
    )

    const aggregateCount = await directusClient.request<{ count: number }[]>(
      readItems(collectionName, {
        filter,
        aggregate: { count: '*' },
      })
    )

    const items = itemsRaw?.map(item => {
      return mapEventPreviewFields(item)
    })

    return {
      items,
      page,
      limit,
      total: aggregateCount[0].count,
    }
  } catch (error) {
    return {
      items: [],
      page,
      limit,
      total: 0,
    }
  }
}
